import React from 'react'

export interface ExcelColumnDef<T> {
  k?: string
  key?: string
  h?: string
  header?: string
  w?: number
  width?: number
  num?: boolean
  isNumeric?: boolean
  ctr?: boolean
  align?: 'left' | 'center' | 'right'
  frozen?: boolean
  get?: (row: T) => any
  getValue?: (row: T) => any
  sv?: (row: T) => any
  render?: (row: T, index: number) => React.ReactNode
  renderCell?: (row: T, index: number) => React.ReactNode
  cls?: (row: T) => string | undefined
  tip?: (row: T) => string | undefined
  tooltip?: (row: T) => string | undefined
  link?: boolean
  isLink?: boolean
  edit?: (row: T) => boolean
  set?: (row: T, val: string) => string | void
  opts?: string[] | ((row: T) => string[])
}

export function getColKey<T>(col: ExcelColumnDef<T>): string {
  return col.k || (col as any).key || ''
}

export function getColHeader<T>(col: ExcelColumnDef<T>): string {
  return col.h || (col as any).header || ''
}

export function getColWidth<T>(col: ExcelColumnDef<T>): number {
  return col.w || (col as any).width || 100
}

export function getColVal<T>(col: ExcelColumnDef<T>, row: T): any {
  if (typeof col.get === 'function') return col.get(row)
  if (typeof (col as any).getValue === 'function') return (col as any).getValue(row)
  const key = getColKey(col)
  return (row as any)?.[key] ?? ''
}

export function isColNum<T>(col: ExcelColumnDef<T>): boolean {
  return Boolean(col.num || (col as any).isNumeric)
}

export function isColCenter<T>(col: ExcelColumnDef<T>): boolean {
  return Boolean(col.ctr || (col as any).align === 'center')
}

export function isColLink<T>(col: ExcelColumnDef<T>): boolean {
  return Boolean(col.link || (col as any).isLink)
}

export interface SortRule {
  k: string
  dir: 'asc' | 'desc'
}

export interface CellCoord {
  r: number
  c: number
}

export interface CellRange {
  r0: number
  r1: number
  c0: number
  c1: number
}

export interface ExcelGridProps<T> {
  id?: string
  userId?: string
  data: T[]
  columns: ExcelColumnDef<T>[]
  freeze?: number
  isEditing?: boolean
  searchQuery?: string
  total?: (rows: T[]) => Record<string, string | number>
  rowCls?: (row: T, index: number) => string | undefined
  onCellClick?: (row: T, col: ExcelColumnDef<T>, e: React.MouseEvent) => void
  onRowContextMenu?: (row: T, e: React.MouseEvent) => void
  onDataChange?: () => void
  onFilterChange?: (activeFilterCount: number) => void
  clearFilterTrigger?: number
  resetWidthsTrigger?: number
  emptyMessage?: string
  className?: string
  style?: React.CSSProperties
}
